import React, { Component } from 'react'
import CircularProgress from 'material-ui/CircularProgress';



export class ShowDistance extends Component {
	constructor(props){
		super(props);
		this.state = {
			first: props.first
		  , second: props.second
		  , distance: undefined
		  , loaderSize: props.loaderSize
		  , cantCount: false
		  , reason: ''
		}
	}
	componentDidMount(){
		let { first, second } = this.state
		let { callBack } = this.props
		let _this = this
		if(typeof first == 'string' && first != 'Wrong address'){
			first = first.trim().replace(/\s/g, '+')
			if(!first.length){
				this.setState({
					cantCount: true
				  , reason: `No ${(this.props.type == 'Agent')? 'agent':'repairman'} address`
				})
				return
			}
			var request = new XMLHttpRequest();
			function onLoad() {
				if(request.responseText){
					let resp = JSON.parse(request.responseText)
					if(!resp.results.length){
						_this.setState({first: 'Wrong address'})
						_this.setState({distance: 'Wrong address'})
						return false
					}
					callBack(
						resp.results[0].geometry.location
						, 'first'
					)
					_this.setState({first: resp.results[0].geometry.location})
				}
			};

			function onTimeout() {
			    console.log('Timeout');
			    console.log(request.responseText);
			};

			function onError(err) {
			    console.log('General network error');
				console.error(err)
			    console.log(request.responseText);
			};

			request.onload = onLoad;
			request.ontimeout = onTimeout;
			request.onerror = onError;
			request.open('GET', `https://maps.googleapis.com/maps/api/geocode/json?address=${first}&key=AIzaSyD9nTB0Zj_EkiV1qMHp2Fm1d5xN64wnoFM`);
			request.send();
		}
		if(typeof second == 'string' && second != "LOADING"){
			second = second.trim().replace(/\s/g, '+')
			if(!second.length){
				this.setState({
					cantCount: true
				  , reason: 'No property address'
				})
				return
			}
			var requestS = new XMLHttpRequest();

			function onLoad() {
				if(requestS.responseText){
					let resp = JSON.parse(requestS.responseText)
					callBack(
						resp.results[0].geometry.location
						, 'second'
					)
					_this.setState({second: resp.results[0].geometry.location})
				}
			};

			function onTimeout() {
			    console.log('Timeout');
			    console.log(request.responseText);
			};

			function onError(err) {
			    console.log('General network error');
				console.error(err)
			    console.log(request.responseText);
			};

			requestS.onload = onLoad;
			requestS.ontimeout = onTimeout;
			requestS.onerror = onError;
			requestS.open('GET', `https://maps.googleapis.com/maps/api/geocode/json?address=${second}&key=AIzaSyD9nTB0Zj_EkiV1qMHp2Fm1d5xN64wnoFM`);
			requestS.send();
		}
		if(first.lat && second.lat){
			if(this.state.cantCount){
				return
			}
			let R = 6371; // km
			let dLat = (second.lat-first.lat)* Math.PI / 180;
			let dLon = (second.lng-first.lng)* Math.PI / 180;
			let lat1 = first.lat * Math.PI / 180;
			let lat2 = second.lat * Math.PI / 180;

			let a = Math.sin(dLat/2) * Math.sin(dLat/2) +
			        Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(lat1) * Math.cos(lat2);
			let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
			let d = R * c / 1609.34;
			this.setState({distance: d})
		}
	}
	componentWillUpdate(){
		let { first, second, distance } = this.state
		if(this.state.cantCount){
			return
		}
		if(first.lat && second.lat){
			let R = 6371; // km
			let dLat = (second.lat-first.lat)* Math.PI / 180;
			let dLon = (second.lng-first.lng)* Math.PI / 180;
			let lat1 = first.lat * Math.PI / 180;
			let lat2 = second.lat * Math.PI / 180;

			let a = Math.sin(dLat/2) * Math.sin(dLat/2) +
			        Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(lat1) * Math.cos(lat2);
			let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
			let d = R * c / 1.60934;
			if(distance != d){
				this.setState({distance: d})
			}
		}
	}
	render() {
		return(
			<div style={this.props.style}>
				{
					(this.state.distance !== undefined)?
						(this.state.distance != 'Wrong address')? `${this.state.distance.toFixed(2)} miles`: this.state.distance
						:(!this.state.cantCount)?
							<CircularProgress
								size={
									(this.state.loaderSize)?
										this.state.loaderSize
										: 10
								}
							/>
						: this.state.reason
				}
			</div>
		)
	}
}

export default ShowDistance



// WEBPACK FOOTER //
// ./src/components/ShowDistance.js